import CategoryAutocompleteField from 'components/forms/fields/category-autocomplete-field/category-autocomplete-field.component';
import { useCategoryAutocompleteWithoutSearchQuery } from 'components/forms/fields/category-autocomplete-field/category-autocomplete.hooks';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const AddCustomRuleSelectProducts = () => {
  const { t } = useTranslation();
  const selectedProducts = useWatch({ name: 'products' });

  const cat = useCategoryAutocompleteWithoutSearchQuery<{
    id: string;
    label: string;
    category: string;
  }>(
    'products',
    {
      ITEM: {
        label: t('forms.fields.productType.options.item'),
      },
      GROUP: {
        label: t('forms.fields.productType.options.group'),
      },
      MENU: {
        label: t('forms.fields.productType.options.menu'),
      },
    },
    'ITEM',
  );

  return (
    <CategoryAutocompleteField
      {...cat}
      name="products"
      limitTags={2}
      disableCategorySelect={selectedProducts.length > 0}
      autoFocus
      filterOptions={undefined}
    />
  );
};

export default AddCustomRuleSelectProducts;
